import { combineReducers } from "@reduxjs/toolkit";
import testReducer from "./testReducer";
import userReducer from "./userReducer";
import baseReducer from "./baseReducer";
import conversationsReducer from "./conversationsReducer";
import safetyIncidentsReducer from "./safetyIncidentsReducer";
import rolodexReducer from "./rolodexReducer";
import assetReducer from "./assetReducer";
import organizationReducer from "./organizationReducer";
import deploymentReducer from "./deploymentReducer";
import buildReducer from "./buildReducer";
import behaviorConfigReducer from "./behaviorConfigReducer";
import agentConfigReducer from "./agentConfigReducer";
import scheduleReducer from "./scheduleReducer";
import sessionsReducer from "./sessionsReducer";
import assessmentReducer from "./assessmentReducer";
import roleplayReducer from "./roleplayReducer";
import selectorExperienceReducer from "./selectorExperienceReducer";

const rootReducer = combineReducers({
  test: testReducer,
  users: userReducer,
  conversations: conversationsReducer,
  safetyIncidents: safetyIncidentsReducer,
  base: baseReducer,
  rolodex: rolodexReducer,
  assets: assetReducer,
  organizations: organizationReducer,
  deployments: deploymentReducer,
  builds: buildReducer,
  behaviorConfigs: behaviorConfigReducer,
  agentConfigs: agentConfigReducer,
  schedule: scheduleReducer,
  sessions: sessionsReducer,
  assessments: assessmentReducer,
  roleplays: roleplayReducer,
  selectorExperiences: selectorExperienceReducer,
});

export default rootReducer;
